<script lang="ts" setup>
import { StorageType } from 'core'

definePageMeta({
  storage: StorageType.Memory
})

const route = useRoute('contact-form-id')
const id = route.params.id
</script>

<template>
  <PageContactForm v-bind="{ ...route.query, id }" type="contact" />
</template>
